const clientes = [
  {
    name: "Municipio de Merlo",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/2nvci5aw_Municipio_merlo_logo.png",
  },
  {
    name: "Municipio de Baradero",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/1ldnwj6o_unnamed%20%284%29.jpg",
  },
  {
    name: "Municipalidad de Ituzaingó",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/0xa41vy4_escudo-municipal-ituzaingo-unibrand-nicolas-torroglosa-branding.png",
  },
  {
    name: "Correo Argentino",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/zwkeoo9c_Correo-argentino-estado.jpg",
  },
  {
    name: "Celulosa Baradero S.A.",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/36x52sxg_logos-celulosa-02-1.webp",
  },
  {
    name: "Gonna Go!",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/io90gn2o_gonna_go_logo.jpeg",
  },
  {
    name: "Rock en Baradero",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/aph1qhsh_festival-rock-en-baradero-001.jpg",
  },
];

const clubes = [
  {
    name: "Deportivo Merlo",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/b4gys8u3_depmerlo.png",
  },
  {
    name: "Ferrocarril Midland",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/8jipdjm7_D_NQ_NP_857478-MLA75977699188_052024-O.webp",
  },
  {
    name: "Casa de Padua",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/2v8l1up2_cropped-Escudo-Nuevo-PNG-1.png",
  },
  {
    name: "A.S.A.",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/5pkxwrew_A.S.A.%20CLUB.png",
  },
  {
    name: "Club de Regatas Baradero",
    img: "https://customer-assets.emergentagent.com/job_internet-fiber/artifacts/3hldse3o_images%20%287%29.jpeg",
  },
];

const LogoRow = ({ title, items }) => (
  <div>
    <p className="text-center text-xs font-bold uppercase tracking-[0.3em] text-pink-500">
      {title}
    </p>
    <div className="mt-6 grid grid-cols-2 items-center gap-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
      {items.map((c) => (
        <div
          key={c.name}
          className="flex h-32 items-center justify-center rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition-transform hover:scale-105 hover:shadow-md md:h-36"
        >
          <img
            src={c.img}
            alt={c.name}
            className="max-h-full max-w-full object-contain"
          />
        </div>
      ))}
    </div>
  </div>
);

const Clientes = () => (
  <section id="empresa" className="bg-white py-14">
    <div className="mx-auto max-w-7xl px-6">
      <div className="mb-12 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-sky-500">
          Confían en nosotros
        </p>
        <h2 className="mt-3 text-3xl font-black text-slate-900 md:text-5xl">
          Nuestros clientes
        </h2>
      </div>

      <div className="space-y-14">
        <LogoRow title="Instituciones & Empresas" items={clientes} />
        <LogoRow title="Clubes amigos" items={clubes} />
      </div>
    </div>
  </section>
);

export default Clientes;
